import React from 'react';
import { Form, InputNumber, Segmented } from 'antd';
import { PitchPriceModel } from '../utils/pitch';

const PRICE_FIELDS = {
  flat: { label: 'Price, USD', placeholder: '6500' },
  cpc: { label: 'Rate, USD / click', placeholder: '0.05' },
  cpm: { label: 'Rate, USD / 1,000 impressions', placeholder: '0.50' },
};

type PitchPriceFieldProps = {
  id: string;
  model: PitchPriceModel;
  value: number | null;
  onModelChange: (model: PitchPriceModel) => void;
  onValueChange: (value: number | null) => void;
};

export function PitchPriceField({
  id, model, value, onModelChange, onValueChange,
}: PitchPriceFieldProps): React.ReactElement {
  const field = PRICE_FIELDS[model];
  return (
    <>
      <Form.Item label="Pricing model" className="pitch-price-model-field">
        <Segmented<PitchPriceModel>
          block
          className="pitch-price-model"
          options={[
            { label: 'Flat', value: 'flat' },
            { label: 'CPC', value: 'cpc' },
            { label: 'CPM', value: 'cpm' },
          ]}
          value={model}
          onChange={onModelChange}
        />
      </Form.Item>
      <Form.Item label={field.label} htmlFor={id}>
        <InputNumber
          id={id}
          className="pitch-price-input"
          value={value}
          min={0}
          precision={model === 'flat' ? 0 : undefined}
          step={model === 'flat' ? 1 : 0.01}
          inputMode={model === 'flat' ? 'numeric' : 'decimal'}
          placeholder={field.placeholder}
          onChange={onValueChange}
        />
      </Form.Item>
    </>
  );
}
